// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaderboard {
  height: 100vh;
  height: 100dvh;
}

.lb__body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  padding: 0 calc(var(--pad) + 8px) calc(env(safe-area-inset-bottom, 0px) + 28px);
}

/* ---- Big date header with prev/next arrows ---- */
.lb__datenav {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0 16px;
}
.lb__arrow {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 999px;
  border: 1px solid var(--palette-border);
  background: var(--palette-surface);
  color: var(--palette-text);
  cursor: pointer;
}
.lb__arrow svg {
  width: 20px;
  height: 20px;
}
.lb__arrow:disabled {
  opacity: 0.28;
  cursor: default;
}
.lb__date {
  flex: 1;
  min-width: 0;
  text-align: center;
}
.lb__date-main {
  font-size: 1.6rem;
  line-height: 1.1;
  font-weight: 600;
}
.lb__date-sub {
  font-family: var(--font-ui);
  font-size: 0.8rem;
  color: var(--palette-text-muted);
  margin-top: 2px;
}

.lb__empty {
  font-size: 0.85rem;
  color: var(--palette-text-muted);
  background: var(--palette-surface-alt);
  border-radius: 12px;
  padding: 12px 14px;
  margin: 0 0 14px;
  line-height: 1.4;
}

.lb__status {
  font-size: 0.85rem;
  color: var(--palette-text-muted);
  padding: 20px 0;
  text-align: center;
}

/* ---- Score table ---- */
.lb__tablewrap {
  width: calc(100% + 16px);
  margin-inline: -8px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.lbtable {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-variant-numeric: tabular-nums;
}
.lbtable thead th {
  font-family: var(--font-ui);
  font-weight: 700;
  font-size: 0.62rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--palette-text-muted);
  padding-bottom: 8px;
  border-bottom: 1px solid var(--palette-border);
  white-space: nowrap;
}
.lbtable thead th.lbtable__n {
  padding-left: 6px;
}
/* Fixed-width numeric columns so the layout never reflows as values change
   from day to day (e.g. dashes on today vs. three-digit totals on a scored
   day). Widths are set once here and shared by <th> and <td>. */
.lbtable__n {
  width: 52px;
  text-align: right;
  padding-left: 6px;
  white-space: nowrap;
}
.lbtable__rank {
  width: 38px;
  text-align: center;
  padding-left: 8px;
  padding-right: 8px;
  color: var(--palette-text-muted);
}
.lbtable__name {
  width: auto;
  text-align: left;
}

.lbtable__row td {
  padding: 12px 0;
  border-bottom: 1px solid var(--palette-border);
  font-size: 0.95rem;
}
.lbtable__row td.lbtable__n {
  padding-left: 6px;
  padding-right: 0;
}
.lbtable__row td.lbtable__rank {
  position: relative;
  isolation: isolate;
  padding-right: 8px;
  font-family: var(--font-display);
  font-weight: 600;
  color: var(--palette-text-muted);
}
.lbtable__row:last-child td {
  border-bottom: 0;
}

.lbtable__player {
  font-weight: 600;
}
.lbtable__rank-value {
  position: absolute;
  z-index: 1;
  top: calc(50% + 1px);
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  transform: translate(-50%, -50%);
  line-height: 1;
}
.lbtable__rank-value--supporter {
  z-index: 3;
  color: #24170f;
  font-family: var(--font-ui);
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: -0.02em;
}
.lbtable__rank-value--supporter.lbtable__rank-value--medium {
  font-size: 0.66rem;
  letter-spacing: -0.06em;
}
.lbtable__rank-value--supporter.lbtable__rank-value--wide {
  font-size: 0.46rem;
  letter-spacing: -0.08em;
}
.lbtable__rank-value--medium:not(.lbtable__rank-value--supporter) {
  font-size: 0.86rem;
}
.lbtable__rank-value--wide:not(.lbtable__rank-value--supporter) {
  font-size: 0.72rem;
}
.lbtable__rank-value--supporter .lbtable__dash {
  color: inherit;
  font: inherit;
}
.lbtable__premium {
  position: absolute;
  display: block;
  line-height: 0;
}
.lbtable__premium--rank {
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.lbtable__name {
  display: table-cell;
}
/* Keep every name on a single line so a long name can't grow a row's height
   and shift the table as you page between days. */
.lbtable__row td.lbtable__name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/* Inline (not block) so a "Not played" row stays the same height as a played
   row — otherwise the table height jumps as you move between days. */
.lbtable__note {
  margin-left: 8px;
  font-family: var(--font-ui);
  font-size: 0.72rem;
  font-weight: 500;
  color: var(--palette-text-muted);
}

.lbtable__total {
  width: 60px;
  font-weight: 700;
  padding-right: 8px;
}
.lbtable__row td.lbtable__total {
  font-family: var(--font-display);
  font-size: 1.05rem;
  padding-right: 8px;
}

/* Placeholder dash for not-yet-applicable values. Forced to the UI font and a
   muted tone so every column's dash matches — the Total cell's display serif
   otherwise renders a visibly shorter em-dash. */
.lbtable__dash {
  font-family: var(--font-ui);
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--palette-text-muted);
}

/* Highlight the signed-in player's row. Square edges — rounded corners look
   out of place inside a border-collapsed table. */
.lbtable__row--self td {
  background: var(--palette-surface-blue-soft);
}

.lbtable__row--out .lbtable__player {
  color: var(--palette-text-muted);
  font-weight: 500;
}

/* Rows you can open to see that player's found words (past days only). */
.lbtable__player-link {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  padding: 3px 4px;
  margin: -3px -4px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
}
.lbtable__player-link:hover {
  background: var(--palette-surface-blue-soft);
}
.lbtable__player-link:focus,
.lbtable__player-link:focus-visible {
  outline: 2px solid var(--palette-primary);
  outline-offset: 2px;
}
.lbtable__player-link .lbtable__player {
  overflow: hidden;
  text-overflow: ellipsis;
}
/* A small forward chevron hinting the row opens the player's words. */
.lbtable__view {
  width: 16px;
  height: 16px;
  margin-left: 6px;
  vertical-align: middle;
  color: var(--palette-text-muted);
}

.lb__manage {
  margin-top: 24px;
}

.lbtable--names-only .lbtable__name {
  width: 100%;
}

.lbtable--names-only .lbtable__row td {
  padding: 14px 8px;
}

.lbtable--names-only .lbtable__row td.lbtable__name--premium {
  position: relative;
  padding-right: 28px;
}

.lbtable__premium--name {
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
}
`, "",{"version":3,"sources":["webpack://./src/screens/leaderboardScreen.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,+EAA+E;AACjF;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,uCAAuC;EACvC,kCAAkC;EAClC,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,OAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sCAAsC;EACtC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;EACnB,8CAA8C;EAC9C,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;;gEAEgE;AAChE;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,8CAA8C;EAC9C,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,UAAU;EACV,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;AACA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;kDACkD;AAClD;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;qEACqE;AACrE;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;iDAEiD;AACjD;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;kDACkD;AAClD;EACE,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,yEAAyE;AACzE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;AACA;EACE,4CAA4C;AAC9C;AACA;;EAEE,yCAAyC;EACzC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA,sEAAsE;AACtE;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,2BAA2B;AAC7B","sourcesContent":[".leaderboard {\n  height: 100vh;\n  height: 100dvh;\n}\n\n.lb__body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior-y: contain;\n  padding: 0 calc(var(--pad) + 8px) calc(env(safe-area-inset-bottom, 0px) + 28px);\n}\n\n/* ---- Big date header with prev/next arrows ---- */\n.lb__datenav {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 0 16px;\n}\n.lb__arrow {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 999px;\n  border: 1px solid var(--palette-border);\n  background: var(--palette-surface);\n  color: var(--palette-text);\n  cursor: pointer;\n}\n.lb__arrow svg {\n  width: 20px;\n  height: 20px;\n}\n.lb__arrow:disabled {\n  opacity: 0.28;\n  cursor: default;\n}\n.lb__date {\n  flex: 1;\n  min-width: 0;\n  text-align: center;\n}\n.lb__date-main {\n  font-size: 1.6rem;\n  line-height: 1.1;\n  font-weight: 600;\n}\n.lb__date-sub {\n  font-family: var(--font-ui);\n  font-size: 0.8rem;\n  color: var(--palette-text-muted);\n  margin-top: 2px;\n}\n\n.lb__empty {\n  font-size: 0.85rem;\n  color: var(--palette-text-muted);\n  background: var(--palette-surface-alt);\n  border-radius: 12px;\n  padding: 12px 14px;\n  margin: 0 0 14px;\n  line-height: 1.4;\n}\n\n.lb__status {\n  font-size: 0.85rem;\n  color: var(--palette-text-muted);\n  padding: 20px 0;\n  text-align: center;\n}\n\n/* ---- Score table ---- */\n.lb__tablewrap {\n  width: calc(100% + 16px);\n  margin-inline: -8px;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.lbtable {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  font-variant-numeric: tabular-nums;\n}\n.lbtable thead th {\n  font-family: var(--font-ui);\n  font-weight: 700;\n  font-size: 0.62rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--palette-text-muted);\n  padding-bottom: 8px;\n  border-bottom: 1px solid var(--palette-border);\n  white-space: nowrap;\n}\n.lbtable thead th.lbtable__n {\n  padding-left: 6px;\n}\n/* Fixed-width numeric columns so the layout never reflows as values change\n   from day to day (e.g. dashes on today vs. three-digit totals on a scored\n   day). Widths are set once here and shared by <th> and <td>. */\n.lbtable__n {\n  width: 52px;\n  text-align: right;\n  padding-left: 6px;\n  white-space: nowrap;\n}\n.lbtable__rank {\n  width: 38px;\n  text-align: center;\n  padding-left: 8px;\n  padding-right: 8px;\n  color: var(--palette-text-muted);\n}\n.lbtable__name {\n  width: auto;\n  text-align: left;\n}\n\n.lbtable__row td {\n  padding: 12px 0;\n  border-bottom: 1px solid var(--palette-border);\n  font-size: 0.95rem;\n}\n.lbtable__row td.lbtable__n {\n  padding-left: 6px;\n  padding-right: 0;\n}\n.lbtable__row td.lbtable__rank {\n  position: relative;\n  isolation: isolate;\n  padding-right: 8px;\n  font-family: var(--font-display);\n  font-weight: 600;\n  color: var(--palette-text-muted);\n}\n.lbtable__row:last-child td {\n  border-bottom: 0;\n}\n\n.lbtable__player {\n  font-weight: 600;\n}\n.lbtable__rank-value {\n  position: absolute;\n  z-index: 1;\n  top: calc(50% + 1px);\n  left: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  transform: translate(-50%, -50%);\n  line-height: 1;\n}\n.lbtable__rank-value--supporter {\n  z-index: 3;\n  color: #24170f;\n  font-family: var(--font-ui);\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n}\n.lbtable__rank-value--supporter.lbtable__rank-value--medium {\n  font-size: 0.66rem;\n  letter-spacing: -0.06em;\n}\n.lbtable__rank-value--supporter.lbtable__rank-value--wide {\n  font-size: 0.46rem;\n  letter-spacing: -0.08em;\n}\n.lbtable__rank-value--medium:not(.lbtable__rank-value--supporter) {\n  font-size: 0.86rem;\n}\n.lbtable__rank-value--wide:not(.lbtable__rank-value--supporter) {\n  font-size: 0.72rem;\n}\n.lbtable__rank-value--supporter .lbtable__dash {\n  color: inherit;\n  font: inherit;\n}\n.lbtable__premium {\n  position: absolute;\n  display: block;\n  line-height: 0;\n}\n.lbtable__premium--rank {\n  z-index: 2;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.lbtable__name {\n  display: table-cell;\n}\n/* Keep every name on a single line so a long name can't grow a row's height\n   and shift the table as you page between days. */\n.lbtable__row td.lbtable__name {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n/* Inline (not block) so a \"Not played\" row stays the same height as a played\n   row — otherwise the table height jumps as you move between days. */\n.lbtable__note {\n  margin-left: 8px;\n  font-family: var(--font-ui);\n  font-size: 0.72rem;\n  font-weight: 500;\n  color: var(--palette-text-muted);\n}\n\n.lbtable__total {\n  width: 60px;\n  font-weight: 700;\n  padding-right: 8px;\n}\n.lbtable__row td.lbtable__total {\n  font-family: var(--font-display);\n  font-size: 1.05rem;\n  padding-right: 8px;\n}\n\n/* Placeholder dash for not-yet-applicable values. Forced to the UI font and a\n   muted tone so every column's dash matches — the Total cell's display serif\n   otherwise renders a visibly shorter em-dash. */\n.lbtable__dash {\n  font-family: var(--font-ui);\n  font-size: 0.95rem;\n  font-weight: 500;\n  color: var(--palette-text-muted);\n}\n\n/* Highlight the signed-in player's row. Square edges — rounded corners look\n   out of place inside a border-collapsed table. */\n.lbtable__row--self td {\n  background: var(--palette-surface-blue-soft);\n}\n\n.lbtable__row--out .lbtable__player {\n  color: var(--palette-text-muted);\n  font-weight: 500;\n}\n\n/* Rows you can open to see that player's found words (past days only). */\n.lbtable__player-link {\n  display: inline-flex;\n  align-items: center;\n  max-width: 100%;\n  padding: 3px 4px;\n  margin: -3px -4px;\n  border: 0;\n  border-radius: 4px;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n}\n.lbtable__player-link:hover {\n  background: var(--palette-surface-blue-soft);\n}\n.lbtable__player-link:focus,\n.lbtable__player-link:focus-visible {\n  outline: 2px solid var(--palette-primary);\n  outline-offset: 2px;\n}\n.lbtable__player-link .lbtable__player {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n/* A small forward chevron hinting the row opens the player's words. */\n.lbtable__view {\n  width: 16px;\n  height: 16px;\n  margin-left: 6px;\n  vertical-align: middle;\n  color: var(--palette-text-muted);\n}\n\n.lb__manage {\n  margin-top: 24px;\n}\n\n.lbtable--names-only .lbtable__name {\n  width: 100%;\n}\n\n.lbtable--names-only .lbtable__row td {\n  padding: 14px 8px;\n}\n\n.lbtable--names-only .lbtable__row td.lbtable__name--premium {\n  position: relative;\n  padding-right: 28px;\n}\n\n.lbtable__premium--name {\n  top: 50%;\n  right: 8px;\n  transform: translateY(-50%);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
